var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSorry(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.448,
    height: 59.57,
    viewBox: "0 0 82.448 59.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#5296F0;}.b,.e{fill:none;stroke:#222;stroke-linecap:round;}.b{stroke-linejoin:round;stroke-width:3px;}.c{fill:#E3E000;}.d{fill:#222;}.e{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.547 0.293)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1612.565,1935.324l-2.407.252a7.937,7.937,0,0,0-4.881,2.376l-4.132,4.271a1.687,1.687,0,0,1-2.68-.343l-4.4-7.783a1.683,1.683,0,0,0-1.4-.855l-10.973-.4a1.683,1.683,0,0,0-1.291,2.844,3.956,3.956,0,0,0,.359.312c1.646,1.271,5.9,2.181,7.6,2.505a1.681,1.681,0,0,1,1.113.769l9.113,14.748a1.686,1.686,0,0,0,2.769.144l4.358-4.331s-3.3,7.059,0,7.073,25.153.1,26.621,0,.636-7.815.636-7.815l4.787,5.431a1.686,1.686,0,0,0,2.768-.145l9.113-14.747a1.679,1.679,0,0,1,1.114-.769c1.7-.324,5.953-1.235,7.6-2.505a3.831,3.831,0,0,0,.359-.313,1.683,1.683,0,0,0-1.291-2.844l-10.972.4a1.688,1.688,0,0,0-1.406.856l-4.4,7.783a1.686,1.686,0,0,1-2.679.342l-4.132-4.27a7.945,7.945,0,0,0-4.881-2.377l-2.408-.251-6.79,3.633Z",
    transform: "translate(-1578.283 -1897.672)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1455.786 -1898.617)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1481.576,1948.665v7.074h27.011l.247-7.815m-6.43-13.406-6.791,3.633-7.178-3.991m23.649,21.579"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M289.514,207.92s2.913,7.508,6.924,7.594a15.511,15.511,0,0,0,7.321-1.842l3.663.906h2.94l5.611.937s2.1-13.669-11.242-16.285S289.514,207.92,289.514,207.92Z",
    transform: "translate(1194.354 1699.782)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1488.435,1934.16l-2.408.252a7.948,7.948,0,0,0-4.881,2.376l-4.132,4.271a1.685,1.685,0,0,1-2.679-.343l-4.4-7.783a1.686,1.686,0,0,0-1.406-.855l-10.972-.4a1.683,1.683,0,0,0-1.291,2.844,3.827,3.827,0,0,0,.359.312c1.645,1.271,5.9,2.181,7.6,2.505a1.683,1.683,0,0,1,1.114.769l9.113,14.748a1.686,1.686,0,0,0,2.768.145l6.664-7.791"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1484.215,1907.644a12.8,12.8,0,0,1,11.812-7.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1496.027,1899.824a12.8,12.8,0,0,1,12.817,12.807,23.978,23.978,0,0,1-1.81,8.508,18.072,18.072,0,0,1-5.354,7.616,9.912,9.912,0,0,1-2.617,1.469,8.674,8.674,0,0,1-3.026.548h-.022a8.674,8.674,0,0,1-3.026-.548,9.888,9.888,0,0,1-2.619-1.469,15.76,15.76,0,0,1-3.968-4.743,24.687,24.687,0,0,1-3.194-11.381"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1487.118,1910.542c3,2.313,5.169,2.51,6.587,2.106,2.485-.709,4.434-3.555,4.785-3.212.226.221.546,2.124.881,2.588.406.562,1.986-1.6,3.779-1.4,1.346.154,4.472,1.248,5.214,2.14"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 2.078,
    cy: 1.412,
    rx: 2.078,
    ry: 1.412,
    transform: "translate(1489.075 1916.368)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 2.078,
    cy: 1.412,
    rx: 2.078,
    ry: 1.412,
    transform: "translate(1498.993 1916.368)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1494.694,1925.326s4.322-1.668,5.441-.479",
    transform: "translate(-0.837)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1502.4,1934.518l2.408.252a7.938,7.938,0,0,1,4.88,2.376l4.133,4.27a1.685,1.685,0,0,0,2.679-.342l4.4-7.783a1.683,1.683,0,0,1,1.4-.855l10.973-.4a1.683,1.683,0,0,1,1.291,2.843,3.96,3.96,0,0,1-.359.313c-1.646,1.271-5.9,2.181-7.6,2.505a1.678,1.678,0,0,0-1.113.769l-9.113,14.748a1.687,1.687,0,0,1-2.769.144l-6.663-7.79",
    transform: "translate(-1455.786 -1898.617)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorry);
export default __webpack_public_path__ + "static/media/Sorry.667d68d9f277ca6fbf8d1e55337a4669.svg";
export { ForwardRef as ReactComponent };